import React from "react";
import { Form } from "antd";
import ColorOptions from "./ColorOptions";

const ButtonTab = ({ bgcolorBadge, handleChangeColors }) => {
  return (
    <Form
      name="basic"
      style={{ maxWidth: "100%", width: "100%", fontWeight: 600 }}
      autoComplete="off"
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 16 }}
      colon={false}
    >
      <Form.Item label="Background Color">
        <ColorOptions value={bgcolorBadge} onChange={handleChangeColors} />
      </Form.Item>
    </Form>
  );
};

export default ButtonTab;
